import axios from 'axios'

const baseURL = process.env.VUE_APP_CYLINDER_SERVICE + '/api/admin/settings'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getSettings ({
      state,
      commit
    }) {
      return axios.get(baseURL)
    },
    async getArticle ({
      state,
      commit
    }, id) {
      const promise = axios.get(baseURL + '/' + id, {})

      promise.then(response => {
        commit('setArticle', response.data.data)
      }).catch(e => {
      })
      return promise
    },
    async saveSettings ({
      state,
      commit
    }, data) {
      return axios.post(baseURL, data)
    }
  }
}
